//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
/** Components Import */
import M_TBS_CUSTOM from './M_TBS_CUSTOM';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Global from '../../../../Services/Common/Global';
/** Query */
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSearch5,
  useSearch6,
  useSearch7,
  useSearch8,
  useSave1,
  useSave2,
} from './M_TBS_CUSTOM_Query';
import { useSave } from '../../../../Hooks/useSave';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { TbmActions } from '../../../../Reducer/TbmReducer';
import Commons from '../../../../Services/Common/Common';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

//#region 상수
const MAX_MULTI_SELECT = 3;
//#endregion

//#region 헬퍼 함수
const GetEducationPath = (item) => item?.eduLocation || item?.eduFilePath || '';
const GetEducationName = (item) =>
  item?.eduFileName || GetEducationPath(item)?.split('/')?.pop() || '';
const GetVideoPath = (item) => item?.videoLocation || item?.videoFilePath || '';
const GetVideoName = (item) =>
  item?.videoFileName || GetVideoPath(item)?.split('/')?.pop() || '';
const GetWorkplanPath = (item) => item?.filePath || '';
const GetWorkplanName = (item) => {
  const fullName =
    GetWorkplanPath(item)?.split('/')?.pop() || item?.fileName || '';
  const firstUnderscoreIndex = fullName.indexOf('_');
  if (firstUnderscoreIndex === -1) return fullName;
  return fullName.substring(firstUnderscoreIndex + 1);
};
const IsSameEducation = (a, b) =>
  GetEducationPath(a) && GetEducationPath(a) === GetEducationPath(b);
const IsSameWorkplan = (a, b) =>
  GetWorkplanPath(a) && GetWorkplanPath(a) === GetWorkplanPath(b);
const NormalizePaths = (paths = []) =>
  [...paths].filter(Boolean).sort().join('|');
//#endregion

function M_TBS_CUSTOMF(props) {
  //#region 변수
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const codeInfo = useSelector((state) => state.code.codeInfo);
  const { sessionData, stepData } = useSelector((state) => state.tbm);

  const [selectedType, setSelectedType] = useState(null);
  const [listDialogOpen, setListDialogOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [listTitle, setListTitle] = useState('');
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedEducations, setSelectedEducations] = useState([]);
  const [selectedWorkplans, setSelectedWorkplans] = useState([]);
  const [workpermitFlag, setWorkpermitFlag] = useState(null);

  const videoRef = useRef();
  const originPathsRef = useRef(null); // 교육동영상, 교육파일, 작업계획서 초기 경로
  //#endregion

  useBackStack({
    type: 'navigate',
    onBack: () => {
      setSelectedVideo(null);
      setSelectedEducations([]);
      setSelectedWorkplans([]);
      navigate('/Home');
    },
  });

  //#region 이벤트
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('TBM 자료 선택'));
    Search4Async();
    Search7Async();
  }, [dispatch]);
  //#endregion

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      setListData(rows);
      setListTitle('교육 동영상 선택');
      setListDialogOpen(true);
    },
  });
  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      setListData(rows);
      setListTitle('교육 파일 선택');
      setListDialogOpen(true);
    },
  });
  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      // 작업계획서 데이터 처리
      const transformedData = (rows || []).map((item) => ({
        chaebun: item.chaebun,
        createDate: item.createDate,
        createId: item.createId,
        custCd: item.custCd,
        date: item.date,
        fileName: item.fileName,
        filePath: item.filePath,
        saveName: item.saveName,
        updateDate: item.updateDate,
        updateId: item.updateId,
      }));
      setListData(transformedData);
      setListTitle('작업계획서 선택');
      setListDialogOpen(true);
    },
  });
  const { runAsync: Search4Async } = useSearch4({
    onSuccess: (rows) => {
      const data = rows?.[0];

      // 참석자, 스탭 테이블의 데이터가 비어있을때를 대비해 if문 안에서 빼냄
      Search5Async();

      // 진행중인 TBM 있는 경우 M_ToolBoxMeeting로 이동 없으면 선택 화면 표시
      if (!data || data.sessionStatus === 'CLOSE') {
        Search8Async();
        dispatch(TbmActions.setSessionData(data));
        const contents = data?.contents || [];
        const videoContent = contents
          .filter((c) => c.stepCode === 'TBM_VIDEO')
          .sort((a, b) => Number(a.contentOrder) - Number(b.contentOrder));
        const eduContents = contents
          .filter((c) => c.stepCode === 'TBM_DOCS')
          .sort((a, b) => Number(a.contentOrder) - Number(b.contentOrder));
        const planContents = contents
          .filter((c) => c.stepCode === 'TBM_PLAN')
          .sort((a, b) => Number(a.contentOrder) - Number(b.contentOrder));

        const videoPath =
          videoContent.length > 0
            ? videoContent.map((c) => c.filePath)
            : data?.videoPath
              ? [data.videoPath]
              : [];
        const eduPaths =
          eduContents.length > 0
            ? eduContents.map((c) => c.filePath)
            : data?.filePath
              ? [data.filePath]
              : [];
        const planPaths =
          planContents.length > 0
            ? planContents.map((c) => c.filePath)
            : data?.planPath
              ? [data.planPath]
              : [];

        originPathsRef.current = {
          videoPath,
          filePaths: eduPaths,
          planPaths,
        };

        setSelectedVideo(
          videoContent.length > 0
            ? {
                videoLocation: videoContent[0].filePath,
                videoFileName:
                  videoContent[0].fileName ||
                  videoContent[0].filePath?.split('/')?.pop(),
                sourceType: videoContent[0].sourceType ?? 'EDU_VIDEO',
                sourceId: videoContent[0].sourceId ?? '',
                lastPosition: videoContent[0].lastPosition ?? '0',
              }
            : data?.videoPath
              ? {
                  videoLocation: data.videoPath,
                  videoFileName: data.videoPath.split('/')?.pop(),
                  sourceType: 'EDU_VIDEO',
                  sourceId: '',
                  lastPosition: '0',
                }
              : null
        );
        setSelectedEducations(
          eduContents.length > 0
            ? eduContents.map((c) => ({
                eduLocation: c.filePath,
                eduFileName: c.fileName || c.filePath?.split('/')?.pop(),
                lastPosition: c.lastPosition ?? '0',
              }))
            : data?.filePath
              ? [
                  {
                    eduLocation: data.filePath,
                    eduFileName: data.filePath?.split('/')?.pop(),
                    lastPosition: '0',
                  },
                ]
              : []
        );
        setSelectedWorkplans(
          planContents.length > 0
            ? planContents.map((c) => ({
                filePath: c.filePath,
                fileName:
                  c.fileName ||
                  GetWorkplanName({
                    filePath: c.filePath,
                    fileName: c.fileName,
                  }),
                chaebun: c.sourceId,
                lastPosition: c.lastPosition ?? '0',
              }))
            : data?.planPath
              ? [
                  {
                    filePath: data.planPath,
                    fileName: GetWorkplanName({ filePath: data.planPath }),
                    lastPosition: '0',
                  },
                ]
              : []
        );
      } else {
        Search6Async({ sessionCd: data.sessionCd });
      }
    },
  });
  const { runAsync: Search5Async } = useSearch5({
    onSuccess: (rows) => {
      const stepByCode = new Map(rows.map((r) => [r.stepCode, r]));
      const defaultStepData = codeInfo
        .filter((f) => f.groupCd === 'TBM_STEP')
        .map((item) => {
          const prev = stepByCode.get(item.code);
          return {
            stepOrder: Number(item.val1),
            stepCode: item.code,
            isRequired: 'Y',
            isSkipAllowed: 'Y',
            curContentOrder: prev?.curContentOrder ?? 1,
            lastPosition: prev?.lastPosition ?? '0',
          };
        });
      dispatch(TbmActions.setStepData(defaultStepData));

      // 외부인은 초기 데이터 로드 후 자동 저장(바로 tbm 화면으로 이동)
      userInfo?.internalYn === '1' && SaveLogic1(defaultStepData);
    },
  });
  const { runAsync: Search6Async } = useSearch6({
    onSuccess: (rows) => {
      if (rows.length > 0) {
        const host = rows.find((f) => f.hostYn === 'Y');
        dispatch(TbmActions.setParticipantData(host));
        navigate('/M_TBMManager');
      }
    },
  });
  const { runAsync: Search7Async } = useSearch7({
    onSuccess: (rows) => {
      // 작업허가서 유무
      const pmCds = rows
        .filter((r) => r.smSign === 'Y' && r.depSign === 'Y')
        .map((r) => String(r.pmCd))
        .filter(Boolean);

      setWorkpermitFlag(pmCds.length > 0);
    },
  });
  const { runAsync: Search8Async } = useSearch8({
    onSuccess: (rows) => {
      // 이전 TBM 이력이 있는 경우
      if (rows.length > 0) {
        dispatch(
          TbmActions.setContentData(
            rows.map((r) => ({
              stepOrder: Number(r.stepOrder),
              stepCode: r.stepCode,
              contentOrder: r.contentOrder ?? '1',
              filePath: r.filePath ?? '',
              fileName: r.fileName ?? '',
              sourceType: r.sourceType ?? '',
              sourceId: r.sourceId ?? '',
              lastPosition: r.lastPosition ?? '0',
            }))
          )
        );
        return;
      }
    },
  });
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();

  // 저장
  const { run: Save1 } = useSave({
    menuId: 'M_TBS_CUSTOM',
    requestSave: (rows) => Save1Async(rows),
    onSuccess: async (rows) => {
      const data = rows.saveDetailData[0].data[0];
      dispatch(TbmActions.setSessionData(data)); // 저장 후 sessionData 업데이트
      dispatch(TbmActions.setContentData(data.contents)); // 저장 후 contentData 업데이트

      const result = await Save2Async([
        {
          sessionCd: data.sessionCd,
          hostYn: 'Y',
          stayTime: 0,
        },
      ]);

      dispatch(TbmActions.setParticipantData(result.data[0].data[0])); // 저장 후 participantData 업데이트

      navigate('/M_TBMManager');
    },
  });

  const SaveLogic1 = async (_stepData) => {
    try {
      const videoFile = selectedVideo
        ? [
            {
              filePath: GetVideoPath(selectedVideo),
              fileName: GetVideoName(selectedVideo),
              sourceType: selectedVideo.sourceType ?? 'EDU_VIDEO',
              sourceId: selectedVideo.sourceId ?? '',
              contentOrder: 1,
              lastPosition: selectedVideo.lastPosition ?? '0',
            },
          ]
        : [];
      const videoPath = videoFile[0]?.filePath || '';
      const eduFiles = selectedEducations.map((item, index) => ({
        filePath: GetEducationPath(item),
        fileName: GetEducationName(item),
        sourceType: 'EDU_FILE',
        sourceId: item.sourceId ?? '',
        contentOrder: index + 1,
        lastPosition: item.lastPosition ?? '0',
      }));
      const planFiles = selectedWorkplans.map((item, index) => ({
        filePath: GetWorkplanPath(item),
        fileName: GetWorkplanName(item),
        sourceType: 'SAF_BASIC',
        sourceId: item.chaebun ?? item.sourceId ?? '',
        contentOrder: index + 1,
        lastPosition: item.lastPosition ?? '0',
      }));
      const workpermit = workpermitFlag;

      // _stepData : 외부인 초기데이터, stepData : 내부인 기존데이터
      const targetSteps = _stepData || stepData;

      // 경로있는 페이지만 필터링
      const includedSteps = targetSteps.filter((item) => {
        if (item.stepCode === 'TBM_VIDEO' && videoFile.length === 0)
          return false;
        if (item.stepCode === 'TBM_DOCS' && eduFiles.length === 0) return false;
        if (item.stepCode === 'TBM_PLAN' && planFiles.length === 0)
          return false;
        if (item.stepCode === 'TBM_PERMIT' && !workpermit) return false;
        return true;
      });

      // 오름차순 정렬
      const orderedIncludedSteps = [...includedSteps].sort(
        (a, b) => Number(a.stepOrder) - Number(b.stepOrder)
      );

      // stepOrder 1부터 순서대로 부여
      // Search4 초기 경로와 다른 단계는 자료가 바뀐 것이므로 lastPosition 0
      const initialPaths = originPathsRef.current;
      const renumberedSteps = orderedIncludedSteps.map((item, index) => {
        let lastPosition = item.lastPosition;

        if (initialPaths) {
          if (
            item.stepCode === 'TBM_VIDEO' &&
            NormalizePaths(videoFile.map((f) => f.filePath)) !==
              NormalizePaths(initialPaths.videoPath)
          ) {
            lastPosition = '0';
          } else if (
            item.stepCode === 'TBM_DOCS' &&
            NormalizePaths(eduFiles.map((f) => f.filePath)) !==
              NormalizePaths(initialPaths.filePaths)
          ) {
            lastPosition = '0';
          } else if (
            item.stepCode === 'TBM_PLAN' &&
            NormalizePaths(planFiles.map((f) => f.filePath)) !==
              NormalizePaths(initialPaths.planPaths)
          ) {
            lastPosition = '0';
          } else if (
            item.stepCode === 'TBM_PERMIT' &&
            sessionData.sessionStatus === 'CLOSE'
          ) {
            lastPosition = '0';
          }
        }
        return {
          stepOrder: String(index + 1),
          stepCode: item.stepCode,
          isRequired: 'Y',
          isSkipAllowed: 'Y',
          curContentOrder: item.curContentOrder ?? 1,
          lastPosition,
        };
      });

      const curSteps = renumberedSteps[0];
      const sessionSteps = renumberedSteps.map((item) => ({
        stepOrder: Commons.EncryptAES(item.stepOrder),
        stepCode: Commons.EncryptAES(item.stepCode),
        isRequired: Commons.EncryptAES('Y'),
        isSkipAllowed: Commons.EncryptAES('Y'),
        curContentOrder: Commons.EncryptAES(String(item.curContentOrder ?? 1)),
        lastPosition: Commons.EncryptAES(item.lastPosition),
      }));
      dispatch(TbmActions.setStepData(renumberedSteps)); // 저장 후 stepData 업데이트
      // 1. TBM 정보 저장
      await Save1([
        {
          curStepOrder: curSteps.stepOrder,
          curStepCode: curSteps.stepCode,
          curPosition: curSteps.lastPosition,
          videoPath: videoPath,
          filePath: '',
          planPath: '',
          videoFile, // content 테이블 저장
          eduFiles, // content 테이블 저장
          planFiles, // content 테이블 저장
          sessionSteps: sessionSteps, // step 테이블 저장
        },
      ]);
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    }
  };
  //#endregion

  //#region 나머지 함수
  const HandleSelectType = async (type) => {
    setSelectedType(type);
    try {
      if (type === 'video') {
        await Search1Async();
      } else if (type === 'education') {
        await Search2Async();
      } else if (type === 'workplan') {
        await Search3Async();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const HandleSelectItem = (item) => {
    setPreviewItem(item);
    setListDialogOpen(false);
    setPreviewDialogOpen(true);
  };

  const HandleConfirmPreview = (item = null) => {
    if (item === null) {
      if (selectedType === 'video') setSelectedVideo(null);
      return;
    }

    const selectedItem = item || previewItem;

    if (selectedType === 'video') {
      setSelectedVideo({
        ...selectedItem,
        sourceType: selectedItem.sourceType ?? 'EDU_VIDEO',
        sourceId: selectedItem.sourceId ?? '',
        lastPosition: selectedItem.lastPosition ?? '0',
      });
      dispatch(
        showSnackbar({
          message: '교육 동영상이 선택되었습니다.',
          type: 'success',
        })
      );
    }

    setPreviewDialogOpen(false);
    setListDialogOpen(false);
    setPreviewItem(null);
  };

  const HandleToggleMultiSelect = (item) => {
    if (selectedType === 'education') {
      const exists = selectedEducations.some((selected) =>
        IsSameEducation(selected, item)
      );

      if (exists) {
        setSelectedEducations((prev) =>
          prev.filter((selected) => !IsSameEducation(selected, item))
        );
        return;
      }

      if (selectedEducations.length >= MAX_MULTI_SELECT) {
        dispatch(
          showSnackbar({
            message: `교육 파일은 최대 ${MAX_MULTI_SELECT}개까지 선택할 수 있습니다.`,
            type: 'warning',
          })
        );
        return;
      }

      setSelectedEducations((prev) => [...prev, item]);
      return;
    }

    if (selectedType === 'workplan') {
      const exists = selectedWorkplans.some((selected) =>
        IsSameWorkplan(selected, item)
      );

      if (exists) {
        setSelectedWorkplans((prev) =>
          prev.filter((selected) => !IsSameWorkplan(selected, item))
        );
        return;
      }

      if (selectedWorkplans.length >= MAX_MULTI_SELECT) {
        dispatch(
          showSnackbar({
            message: `작업계획서는 최대 ${MAX_MULTI_SELECT}개까지 선택할 수 있습니다.`,
            type: 'warning',
          })
        );
        return;
      }

      setSelectedWorkplans((prev) => [...prev, item]);
    }
  };

  const GetFileUrl = (item, type) => {
    if (!item) return '';
    let filePath = '';
    if (type === 'video') {
      filePath = item.videoLocation || item.videoFilePath || '';
    } else if (type === 'education') {
      filePath = item.eduLocation || item.eduFilePath || '';
    } else if (type === 'workplan') {
      filePath = item.filePath || '';
    }
    if (!filePath) return '';
    if (filePath.startsWith('http')) return filePath;
    const fixedPath = Commons.EncodeUrl(filePath);
    return `${Global.file.useUrl}files/${fixedPath}`;
  };

  const GetFileExtension = (url) => {
    if (!url) return '';
    const name = url.split('/').pop();
    return name?.split('.').pop()?.toLowerCase() || '';
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBS_CUSTOM
        userInfo={userInfo}
        selectedType={selectedType}
        HandleSelectType={HandleSelectType}
        ActiveButton={props.ActiveButton}
        selectedVideo={selectedVideo}
        selectedEducations={selectedEducations}
        selectedWorkplans={selectedWorkplans}
        maxMultiSelect={MAX_MULTI_SELECT}
        SaveLogic1={SaveLogic1}
        listDialogOpen={listDialogOpen}
        setListDialogOpen={setListDialogOpen}
        listData={listData}
        listTitle={listTitle}
        HandleSelectItem={HandleSelectItem}
        previewDialogOpen={previewDialogOpen}
        setPreviewDialogOpen={setPreviewDialogOpen}
        previewItem={previewItem}
        setPreviewItem={setPreviewItem}
        HandleConfirmPreview={HandleConfirmPreview}
        HandleToggleMultiSelect={HandleToggleMultiSelect}
        GetFileUrl={GetFileUrl}
        GetFileExtension={GetFileExtension}
        videoRef={videoRef}
      />
    </div>
  );
}

export default M_TBS_CUSTOMF;
